import {
  SET_AUTH_STATE,
} from '../../actions/action-types';


const initialState =  {
  isLoggedIn: false,
  sessionId: null,
  profile: null,
};

export default function authReducer(state = initialState, action) {
  let newState = state;
  switch (action.type) {
    case SET_AUTH_STATE:
      newState = Object.assign ({}, action.payload);
      // console.log('auth-reducer new state: ' + JSON.stringify(newState, null, 2));
      break;
    default:
      break;
  }
  return newState;
}
